import React, { useState } from "react";

import CardsTable from "../components/cards_table/index";
import CardInfoEditDialog from "../components/dialogs/card_info_edit";
import SnackBar from "../components/snackbar";

import { cards_data } from "../constants/table_data";

const CardInfo = () => {

  const [selectedCard, setSelectedCard] = useState({})
  const [openEdit, setOpenEdit] = useState(false);
  const toggleEdit = (value) => setOpenEdit(value);

  const [showMessage, setShowMessage] = useState(false)
  const openMessage = () => setShowMessage(true)
  const closeMessage = () => setShowMessage(false)

  const cardNumber = (cardNumber) => {
    setSelectedCard(cards_data.filter(c => c.cardNumber === cardNumber)[0])
    toggleEdit(true)
  }

  return (
    <div className="page-content px-0 px-sm-4 px-xxl-5 ">
      <div className="ms-0 py-0 py-sm-5">
        <CardsTable 
          tableData={cards_data}
          onClickRow={cardNumber}
        />
      </div>
      <CardInfoEditDialog 
        selectedCard={selectedCard}
        open={openEdit} 
        toggle={toggleEdit}
        onSuccess={openMessage}
      />
      <SnackBar 
        showMessage={showMessage} 
        closeMessage={closeMessage}/>
    </div>
  );
};

export default CardInfo;
